import React from 'react';
import styles from './CancelAdButton.module.scss';
import {MDBBtn, MDBCard, MDBCardBody, MDBCol, MDBPopover, MDBPopoverBody, MDBPopoverHeader, MDBRow} from 'mdbreact';
import {IProduct} from 'data/interfaces/products';
import useToggle from '@react-hook/toggle';
import {Divider, Tooltip} from '@material-ui/core';
import BlockIcon from '@material-ui/icons/Block';
import {When} from 'react-if';
import {isProductOfStatusType} from 'data/redux/selectors/productSelector';
import {PRODUCT_STATUS_TYPE_OPEN} from 'data/redux/constants/productsConstants';
import CircleLoader from '../circleLoader';

interface IAdProps {
  product: IProduct;

  view?: (id: number) => void
  edit?: (id: number) => void
  delete?: (id: number) => void


  className?: string;

  loading?: boolean;

}


const CancelAdButton = ({loading, ...props}: IAdProps) => {
  const [isOn, toggleIsOn] = useToggle(false, true, false);
  return loading ? <CircleLoader/> : (
    <When condition={isProductOfStatusType(props.product, PRODUCT_STATUS_TYPE_OPEN)}>
      {() => <span className={styles.controlButton}>
        <MDBPopover
          placement="bottom"
          popover
          clickable
          isVisible={isOn}
          className={styles.CancelAdButtonContainerPopOver}
        >
           <Tooltip title="ביטול" aria-label="cancel" arrow enterDelay={0}>
            <BlockIcon style={{
              marginTop: 6,
              cursor: "pointer"
            }}
                       onClick={() => !isOn && toggleIsOn()}
            />
           </Tooltip>
            <div>
              <MDBPopoverHeader>בטוח לבטל מודעה?</MDBPopoverHeader>
              <MDBPopoverBody>
                <MDBRow style={{width: 200}}>
                  <MDBCol>
                    <MDBCard color="lighten-1">
                      <MDBCardBody>
                        <MDBRow>
                          <MDBCol>
                            אזהרה!
                          </MDBCol>
                        </MDBRow>
                        <MDBRow>
                          <MDBCol>
                            בטוח לבטל את המודעה?
                          </MDBCol>
                        </MDBRow>
                      </MDBCardBody>
                    </MDBCard>
                  </MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol>
                    <Divider style={{marginBottom: 5, marginTop: 5}}/>
                  </MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol xs="6">
                    <MDBBtn color="default" onClick={() => isOn && toggleIsOn()}>
                      לא
                    </MDBBtn>
                  </MDBCol>
                  <MDBCol xs="6">
                    <MDBBtn className={props.className}
                            color="danger"
                            onClick={() => {
                              isOn && toggleIsOn();
                              return props.delete(props.product.id);
                            }}>
                      כן
                    </MDBBtn>
                  </MDBCol>
                </MDBRow>
              </MDBPopoverBody>
            </div>
          </MDBPopover>
      </span>}
    </When>
  );
};

CancelAdButton.defaultProps = {
  product: {},

  view: () => {
  },
  edit: () => {
  },
  delete: () => {
  },
  className: ''
};
export default CancelAdButton;
